export const vehicleManufacturerSelectConfig = {
    rowKey: "id",
    columns: [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 350,
            sorter: true,
            ellipsis: true,
        },
        {
            title: "Название",
            dataIndex: "name",
            key: "name",
            sorter: true,
            ellipsis: true,
        },
    ],
};
